export enum UrlRoute {
    PARAM = 'PARM',
    PATH ='FULL_URL',
    QUERY_PARAM = 'QUERY'
}